import React, { useState, useEffect } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
// import { DaySelector } from "./day-selector";
import { toast, Bounce } from "react-toastify";

export default function JobScheduleEdit({
  selectJobScheduleRow,
  setForceUpdate,
  forceUpdate,
  activateJobScheduleEdit,
  setActivateJobScheduleEdit,
}) {
  let navigate = useNavigate();
  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }
  const { assign_date, cleaning_type, report_done, college, company, id } =
    selectJobScheduleRow;

  const [campusId, setCampusId] = useState(college?.campus || "");
  const [collegeId, setCollegeId] = useState(college?.id || "");
  const [campusList, setCampusList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [cleaningType, setCleaningType] = useState(cleaning_type);
  const [assignDate, setAssignDate] = useState(assign_date);

  useEffect(() => {
    setCampusId(college?.campus || "");
    setCleaningType(cleaning_type);
    setAssignDate(assign_date);
    setCollegeId(college?.id || "");
  }, [activateJobScheduleEdit, campusList]);

  useEffect(() => {
    if (activateJobScheduleEdit) {
      (async () => {
        let response = await axios(`${baseUrl}/get_campus/`, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        if (response?.status === 200) {
          setCampusList(
            response?.data?.data?.map((m) => ({
              id: m?.id,
              campus_name: m?.campus_name,
            }))
          );
        }
      })();
    }
  }, [activateJobScheduleEdit]);

  // Fetch blocks when campus is selected
  useEffect(() => {
    if (campusId) {
      (async () => {
        try {
          let response = await axios(
            `${baseUrl}/college_based_block_api/?campus=${campusId}`,
            {
              method: "GET",
              headers: {
                Authorization: "Token " + localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            }
          );
          if (response?.status === 200) {
            setBlockList(response?.data?.data || []);
          }
        } catch (error) {
          console.error("Error fetching blocks:", error);
          setBlockList([]);
        }
      })();
    } else {
      setBlockList([]);
    }
  }, [campusId]);

  let ChangeHandler = (e) => {
    setCampusId(parseInt(e.target.value));
    setCollegeId(""); // Reset college selection when campus changes
  };

  let CollegeChangeHandler = (e) => {
    setCollegeId(e.target.value);
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item === arr2[index]);
  };

  const getChangedFields = () => {
    return {
      ...(campusId !== college?.campus ? { campus: Number(campusId) } : {}),
      ...(collegeId !== college?.id ? { college: Number(collegeId) } : {}),
      ...(cleaningType !== cleaning_type
        ? { cleaning_type: cleaningType }
        : {}),
      ...(assignDate !== assign_date ? { assign_date: assignDate } : {}),
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = getChangedFields();
    let response;
    try {
      response = await axios(`${baseUrl}/update_scheduler/${id}/`, {
        method: "PATCH",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });
      if (response?.status === 200) {
        let unique = document.getElementById("close6");
        unique.click();
        setActivateJobScheduleEdit(false);
        setForceUpdate(!forceUpdate);
        toast.success("Edit JobSchedule Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <div
        className="modal fade custom-modal addjobschedule-modal"
        id="editjobschedule"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Edit JobSchedule
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close6"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img
                      src={buildingImg}
                      width="336"
                      height="336"
                      alt="edit-jobschedule"
                    />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            name="jobschedule_companyname"
                            disabled={true}
                            value={company?.name}
                          />
                          <span className="fa fa-building icon" />
                        </div>
                        {activateJobScheduleEdit && campusList?.length > 0 && (
                          <>
                            <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                              <select
                                name="jobschedule"
                                onChange={ChangeHandler}
                                className="form-select"
                                value={campusId}
                              >
                                <option value="">Select College</option>
                                {campusList.map((arr) => {
                                  return (
                                    <option key={arr?.id} value={arr?.id}>
                                      {arr?.campus_name}
                                    </option>
                                  );
                                })}
                              </select>
                              <span className="fa fa-building icon" />
                            </div>

                            <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                              <select
                                name="jobschedule_college"
                                onChange={CollegeChangeHandler}
                                className="form-select"
                                value={collegeId}
                                disabled={!campusId}
                              >
                                <option value="">
                                  {campusId
                                    ? "Select Block"
                                    : "Please select a college first"}
                                </option>
                                {blockList.map((block) => {
                                  return (
                                    <option key={block?.id} value={block?.id}>
                                      {block?.block_name || block?.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <span className="fa fa-building icon" />
                            </div>
                            <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                              <select
                                name="campus"
                                onChange={(e) =>
                                  setCleaningType(e.target.value)
                                }
                                className="form-select"
                                value={cleaningType}
                              >
                                <option value="">
                                  {cleaningType === ""
                                    ? "Select Cleaning Type"
                                    : "Clear Select"}
                                </option>
                                <option value="REGULAR_CLEANING">
                                  Regular Cleaning
                                </option>
                                <option value="TERM_CLEANING">
                                  Term Cleaning
                                </option>
                              </select>
                            </div>
                            <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Start Date"
                                value={assignDate}
                                onChange={(e) => {
                                  setAssignDate(e.target.value);
                                }}
                              />
                            </div>
                          </>
                        )}

                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
